import { render, staticRenderFns } from "./ElButtonPasalinti.vue?vue&type=template&id=422e2d70&scoped=true&"
import script from "./ElButtonPasalinti.vue?vue&type=script&lang=js&"
export * from "./ElButtonPasalinti.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonPasalinti.vue?vue&type=style&index=0&id=422e2d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e2d70",
  null
  
)

export default component.exports